// extracted by css-extract-rspack-plugin
var _1 = "e1";
var _2 = "e3";
var _3 = "e2";
var _4 = "el";
var _5 = "ez";
var _6 = "eu";
var _7 = "et";
var _8 = "es";
var _9 = "c4";
var _a = "cu";
var _b = "ex";
var _c = "ew";
var _d = "ev";
var _e = "ey";
var _f = "er";
var _10 = "e0";
export { _1 as "description", _2 as "favoriteLinkComponent", _3 as "goToText", _4 as "image", _5 as "imageLoaderComponent", _6 as "linkWrapper", _7 as "loading", _8 as "loadingLayout", _9 as "location", _a as "mapLink", _b as "shoppingMallDescription", _c as "shoppingMallDetails", _d as "shoppingMallImage", _e as "shoppingMallLogo", _f as "shoppingMallTileComponent", _10 as "title" }
